import React from 'react';
import './TopBar.css';
import { PhoneIcon, PaperPlaneIcon, FacebookIcon, LinkedinIcon, XIcon, YoutubeIcon } from '../Icons';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="top-bar-container">
        {/* Left Contact Info */}
        <div className="top-bar-contact">
          <a href="tel:+7562359043" className="top-bar-item">
            <PhoneIcon size={14} color="#656B73" />
            <span>+756 235 9043</span>
          </a>
          
          <div className="top-bar-divider" />

          <a href="mailto:info@industryflow.com" className="top-bar-item">
            <PaperPlaneIcon size={14} color="#656B73" />
            <span>info@industryflow.com</span>
          </a>
        </div>

        {/* Right Social Links */}
        <div className="top-bar-socials">
          <a href="#facebook" className="social-icon" aria-label="Facebook">
            <FacebookIcon size={14} />
          </a>
          <a href="#linkedin" className="social-icon" aria-label="LinkedIn">
            <LinkedinIcon size={14} />
          </a>
          <a href="#x" className="social-icon" aria-label="X Twitter">
            <XIcon size={13} />
          </a>
          <a href="#youtube" className="social-icon" aria-label="YouTube">
            <YoutubeIcon size={15} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
